import { render, staticRenderFns } from "./ResidentContactsList.vue?vue&type=template&id=c989d1e2&scoped=true&"
import script from "./ResidentContactsList.vue?vue&type=script&lang=ts&"
export * from "./ResidentContactsList.vue?vue&type=script&lang=ts&"
import style0 from "./ResidentContactsList.vue?vue&type=style&index=0&id=c989d1e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c989d1e2",
  null
  
)

export default component.exports